import { BrowserRouter, Route, Routes } from "react-router-dom";

import { useAuth } from "./AuthContext";
import { KioskProvider } from "./KioskContext";
import { PointProvider } from "./PointContext";
import { MemberProvider } from "./MemberContext";
import { NoticeProvider } from "./NoticeContext";
import Auth from "./screens/Auth";
import Admin from "./screens/Admin";
import Excel from "./screens/Excel";
import Point from "./screens/Point";
import Kiosk from "./screens/Kiosk";
import Notice from "./screens/Notice";
import MemberStatusV2 from "./screens/MemberStatusV2";

const App = () => {
    const { user } = useAuth();

    return (
        <>
            {!user ? (
                <Auth />
            ) : (
                <KioskProvider>
                    <MemberProvider>
                        <PointProvider>
                            <NoticeProvider>
                                <BrowserRouter>
                                    <Routes>
                                        <Route path="/" element={<Kiosk />}></Route>
                                        <Route path="/admin" element={<Admin />}></Route>
                                        <Route path="/excel" element={<Excel />}></Route>
                                        <Route path="/point" element={<Point />}></Route>
                                        <Route path="/notice" element={<Notice />}></Route>
                                        <Route path="/members" element={<MemberStatusV2 />}></Route>
                                    </Routes>
                                </BrowserRouter>
                            </NoticeProvider>
                        </PointProvider>
                    </MemberProvider>
                </KioskProvider>
            )}
        </>
    );
};

export default App;
